import styles from './styles';

import { Loading } from '@cobliteam/base-components';

type LoadingPageProps = {
  message?: string;
};

function LoadingPage({ message }: LoadingPageProps) {
  return (
    <div className={styles.containerLoading}>
      <Loading />
      <div className={styles.containerMessage}>{message || 'Carregando...'}</div>
    </div>
  );
}

export default LoadingPage;
